// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".anim[data-v-6158a0c8]{animation:introAnim-6158a0c8 .5s 0s forwards}@keyframes introAnim-6158a0c8{0%{transform:translateX(-100vw)}to{transform:translateX(0)}}.active[data-v-6158a0c8]{--tw-bg-opacity:1;background-color:#1e4d72;background-color:rgba(30,77,114,var(--tw-bg-opacity));--tw-text-opacity:1;color:#fff;color:rgba(255,255,255,var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
